import {Injectable} from "@angular/core";
import {DataResponse} from "src/app/models/http.models";
import {Observable} from "rxjs";
import {BaseApiService} from "./_baseApiService";
import {
  AnagraficaDto,
  AnagraficaUtenteCandidature,
  AnagraficaUtentePortalePagineCompilate,
  AnagraficaUtenteVarieCVDataDto,
  CandidatureGetListViewModel
} from "../../models/anagrafica.models";
import {ChangePassword, EmailResetPasswordDto} from "../../models/auth.models"

@Injectable()

export class RegistryService extends BaseApiService{

  public getRegistryDetail():Observable<DataResponse<AnagraficaDto>>{
    return this.httpService.get(`PortalsCandidati/GetAnagraficaUtente`);
  }

  public getRegistryCompletedPages():Observable<DataResponse<AnagraficaUtentePortalePagineCompilate>>{
    return this.httpService.get(`PortalsCandidati/GetAnagraficaUtentePagineCompilate`);
  }
  public registryUpdate(model: AnagraficaDto):Observable<DataResponse<Response>>{
    return this.httpService.post(`PortalsCandidati/AnagraficaUtenteAggiornaAnagrafica`, model);
  }
  public getProfilePhoto():Observable<any>{
    return this.httpService.getFile(`PortalsCandidati/GetFotoUtente`);
  }
  public getProfileCv():Observable<any>{
    return this.httpService.getFile(`PortalsCandidati/GetCvUtente`);
  }
  public getInfoAvailabilityAndCv(profileId : number):Observable<DataResponse<AnagraficaUtenteVarieCVDataDto>>{
    return this.httpService.get(`PortalsCandidati/GetInfoDisponibilitaECV?IdAnagraficaUtente=`+profileId);
  }
  public resetPassword(model : EmailResetPasswordDto):Observable<DataResponse<Response>>{
    return this.httpService.post(`PortalsAuth/EmailResetPassword`,model);
  }

  public changePassword(model : ChangePassword):Observable<DataResponse<Response>>{
    return this.httpService.post(`PortalsAuth/ChangePassword`,model);
  }

  public getProfileExport():Observable<any>{
    return this.httpService.getFile(`PortalsCandidati/DownloadDatiPersonali`);
  }

  public candidatureGetList(model : CandidatureGetListViewModel):Observable<DataResponse<AnagraficaUtenteCandidature>>{
    return this.httpService.post(`PortalsCandidati/CandidatureGetList`,model);
  }
}
